import { SHOW_GDPR, HIDE_GDPR } from "../action_types";

const displayReducer = (display = false, action) => {
    switch(action.type) {
        case SHOW_GDPR:
            return true;

        case HIDE_GDPR:
            return false;

        default: return display;
    }
};

export default displayReducer;